import { HttpClient } from '@easydata/core';
import { domel, DefaultDialogService } from '@easydata/ui';
import { equtils } from '@easyquery/core';
function strIsEmpty(str) {
    if (str) {
        return str.trim() === '';
    }
    else
        return true;
}
var baseLicApiUrl = 'https://korzh.com/api/license';
//const baseLicApiUrl = 'https://localhost:44301/api/license';
var eqVersion = '7.2';
var LCDialog = /** @class */ (function () {
    function LCDialog(context) {
        this.http = new HttpClient();
        this.context = context;
    }
    LCDialog.prototype.show = function () {
        var _this = this;
        var dialogService = new DefaultDialogService();
        this.dialogSet = dialogService.createSet([
            {
                closable: false,
                cancelable: false,
                submitOnEnter: true,
                title: 'No license key for EasyQuery',
                body: this.buildStartPage(),
                submitButtonText: 'Submit',
                onInput: this.validateForm.bind(this),
                onSubmit: this.startPageOnSubmit.bind(this)
            },
            {
                closable: false,
                cancelable: false,
                submitOnEnter: true,
                title: 'Please check your inbox',
                body: this.buildCodePage(),
                submitButtonText: 'Get License Key',
                onInput: this.validateForm.bind(this),
                onSubmit: this.codePageOnSubmit.bind(this)
            },
            {
                closable: false,
                cancelable: false,
                submitable: false,
                title: 'Success',
                body: this.buildSuccessPage()
            },
            {
                closable: false,
                cancelable: false,
                submitable: false,
                title: 'Failure',
                body: this.buildFailurePage()
            },
        ]);
        var dialog1 = this.dialogSet.open(0);
        //dialog1.getRootElement();
        setTimeout(function () {
            _this.validateForm(dialog1);
            var emailInput = document.getElementById('eqAuthEmail');
            if (emailInput) {
                emailInput.focus();
            }
        }, 200);
    };
    LCDialog.prototype.isValidForm = function (form) {
        var emailInput = form.querySelector('#eqAuthEmail'); //form.querySelector('[name="email"]') as HTMLInputElement;       
        if (emailInput) {
            return !strIsEmpty(emailInput.value) &&
                emailInput.value
                    .toLowerCase()
                    .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        }
        var codeInput = form.querySelector('#eqAuthCode'); //form.querySelector('[name="code"]') as HTMLInputElement;
        if (codeInput) {
            return !strIsEmpty(codeInput.value) &&
                !isNaN(+codeInput.value) &&
                codeInput.value == codeInput.value.trim() &&
                codeInput.value.length === 6;
        }
        return true;
    };
    LCDialog.prototype.validateForm = function (dialog) {
        var submitButton = dialog.getSubmitButtonElement();
        submitButton.disabled = !this.isValidForm(dialog.getRootElement());
    };
    LCDialog.prototype.addInputField = function (parentBuilder, inputOptions) {
        parentBuilder
            .addChild('label', function (b) { return b
            .attr('for', inputOptions.id)
            .addHtml(inputOptions.label + " " + (inputOptions.required ? '<sup style="color: red">*</sup>' : '') + ": "); })
            .addChild('input', function (b) {
            b.id(inputOptions.id);
            b.name(inputOptions.name || inputOptions.id);
            b.type(inputOptions.type || 'text');
            if (typeof (inputOptions.value) !== 'undefined') {
                b.value(inputOptions.value);
            }
            if (inputOptions.onInput) {
                b.on('input', inputOptions.onInput);
            }
        });
    };
    LCDialog.prototype.buildStartPage = function () {
        var form;
        var controlsPanelBuilder;
        var formBuilder = domel('div');
        formBuilder.addChild('div', function (b) { return b
            .html('<div style="font-size:1.2em">The EasyQuery license key is either absent, invalid or was issued for a different version of the library.</div>' +
            '<div style="font-size:1.2em">Please fill out the form to obtain a valid trial license key.</div>'); });
        formBuilder
            .addClass('kfrm-form')
            .addChild('div', function (b) {
            controlsPanelBuilder = b;
            b.addClass('kfrm-fields label-above');
            b.addClass('kfrm-break-20');
        });
        this.addInputField(controlsPanelBuilder, {
            id: 'eqAuthEmail',
            name: 'email',
            label: 'Email',
            required: true
        });
        this.addInputField(controlsPanelBuilder, {
            id: 'eqAuthName',
            name: 'contactName',
            label: 'Name (optional)',
            required: false
        });
        formBuilder.addChild('div', function (b) { return b
            .html('<div style="margin-top:20px;font-size:0.9em">* By clicking Submit, you agree with Korzh.com <a href="https://korzh.com/terms-of-use">Terms of use</a>' +
            ' and <a href="https://korzh.com/privacy">Privacy policy</a>.</div>' +
            '<div style="font-size:0.9em">You also agree to receive email messages from Korzh.com. This consent may be revoked at any time.</div>'); });
        form = formBuilder.toDOM();
        return form;
    };
    LCDialog.prototype.buildCodePage = function () {
        var form;
        var controlsPanelBuilder;
        var formBuilder = domel('div');
        formBuilder.addChild('div', function (b) { return b
            .html('<div style="font-size:1.2em">We sent a confirmation code to <strong>{{email}}</strong>.</div>' +
            '<div style="font-size:1.2em">Please find it in the email and enter to the text box below</div>'); });
        formBuilder
            .addClass('kfrm-form')
            .addChild('div', function (b) {
            controlsPanelBuilder = b;
            b.addClass('kfrm-fields label-above');
            b.addClass('kfrm-break-20');
        });
        this.addInputField(controlsPanelBuilder, {
            id: 'eqAuthCode',
            name: 'code',
            label: 'Confirmation code',
            required: true
        });
        formBuilder.addChild('div', function (b) { return b
            .html('<div style="margin-top:20px;font-size:0.9em">NB: Don\'t forget to check your SPAM folder ' +
            'if the message does not arrive within the next 5 minutes, and mark it as "Not Spam" if it\'s found there.</div>'); });
        form = formBuilder.toDOM();
        return form.outerHTML;
    };
    LCDialog.prototype.buildSuccessPage = function () {
        var form;
        var formBuilder = domel('div');
        formBuilder.addChild('div', function (b) { return b
            .html('<div style="font-size:1.2em">You have successfully completed the registration process.</div>' +
            '<div style="font-size:1.2em">Please restart your web application to get the key applied.</div>'); });
        form = formBuilder.toDOM();
        return form;
    };
    LCDialog.prototype.buildFailurePage = function () {
        var form;
        var formBuilder = domel('div');
        formBuilder.addChild('div', function (b) { return b
            .html('{{message}}'); });
        form = formBuilder.toDOM();
        return form.outerHTML;
    };
    LCDialog.prototype.startPageOnSubmit = function (dlg) {
        var _this = this;
        var emailInput = document.getElementById('eqAuthEmail');
        var nameInput = document.getElementById('eqAuthName');
        var authEmail = emailInput.value;
        var authName = nameInput.value;
        dlg.disableButtons();
        this.http.post(equtils.combinePath(baseLicApiUrl, 'get-code'), {
            email: authEmail,
            name: authName,
            data: {
                ptag: this.context.backendInfo.type,
                apptype: this.context.backendInfo.subType,
            }
        }, { dataType: 'json' })
            .then(function (result) {
            if (result.status !== 0) {
                throw new Error(result.message);
            }
            var dlg = _this.dialogSet.openNext({ email: authEmail });
            setTimeout(function () {
                _this.validateForm(dlg);
                var codeInput = document.getElementById('eqAuthCode');
                if (codeInput) {
                    codeInput.focus();
                }
            }, 200);
        })
            .catch(function (error) {
            dlg.showAlert(error.message, "error", true);
            dlg.enableButtons();
        });
        return false;
    };
    LCDialog.prototype.codePageOnSubmit = function (dlg) {
        var _this = this;
        var codeInput = document.getElementById('eqAuthCode');
        var authCode = codeInput.value;
        dlg.disableButtons();
        this.http.post(equtils.combinePath(baseLicApiUrl, 'get-key'), {
            token: authCode,
            ptag: this.context.backendInfo.type,
            version: eqVersion
        }, { dataType: 'json' })
            .then(function (result) {
            switch (result.status) {
                case 0:
                    var url = equtils.combinePath(_this.context.getBaseEndpoint(), 'lck');
                    _this.http.post(url, {
                        version: eqVersion,
                        key: result.key
                    }, { dataType: 'json' })
                        .then(function (_) { return _this.dialogSet.openNext(); });
                    break;
                case 2:
                    _this.dialogSet.open(3, {
                        message: '<div style="font-size:1.2em">Your trial license for EasyQuery has expired.</div>' +
                            '<div style="font-size:1.2em">Please <a href="https://korzh.com/support">contact us</a> if you want to extend the trial period.</div>'
                    });
                    break;
                case 3:
                    _this.dialogSet.open(3, {
                        message: '<div style="font-size:1.2em">Your purchased license for EasyQuery has expired.</div>' +
                            '<div style="font-size:1.2em">You need to <a href="https://korzh.com/account">renew the subscription</a> to get a valid license.</div>'
                    });
                    break;
                default:
                    throw new Error(result.message);
            }
        })
            .catch(function (error) {
            dlg.showAlert(error.message, "error", true);
            dlg.enableButtons();
        });
        return false;
    };
    return LCDialog;
}());
export { LCDialog };
export function showNoLicenseAlert(lcv) {
    var title, body, buttonTitle, buttonUrl;
    switch (lcv.__kt) {
        case 1:
            title = 'EasyQuery trial has expired';
            body = "Your trial period for EasyQuery has expired. \n\tYou can send a request to <a href=\"https://korzh.com/account\">extend your trial</a> or <a href=\"https://korzh.com/easyquery/licensing\">buy a license</a> to get rid of all limitations.";
            buttonTitle = 'Buy a license';
            buttonUrl = 'https://korzh.com/easyquery/licensing';
            break;
        case -3:
            title = 'No license key for EasyQuery';
            body = "Please <a href=\"https://korzh.com/easyquery#get-started\">register for a trial</a> \n\tor <a href=\"https://korzh.com/easyquery/licensing\">purchase a license</a> to get a proper product key. <br />\n\tIf you already have a key, please follow <a href=\"https://korzh.com/easyquery/docs/getting-started/product-key\">this guide</a> to apply it.";
            buttonTitle = 'Register trial';
            buttonUrl = 'https://korzh.com/easyquery#get-started';
            break;
        default:
            title = "Invalid key for EasyQuery!";
            body = "The EasyQuery product key is either invalid or was issued for a different version of the library.\n    The version you are using now is 7.2,\n\tso please <a href=\"https://korzh.com/account\">login to your account</a> to get a proper key for version 7.2.";
            buttonTitle = 'Get key';
            buttonUrl = 'https://korzh.com/account';
            break;
    }
    var ds = new DefaultDialogService();
    var dlg = ds.open({
        closable: false,
        cancelable: false,
        submitable: false,
        title: title,
        body: body
    });
    var footer = dlg.getRootElement().querySelector('footer');
    domel(footer)
        .removeClass('align-right')
        .setStyle('justify-content', 'center')
        .addChild('button', function (b) { return b
        .addClass('kfrm-button', 'is-info')
        .addText(buttonTitle)
        .on('click', function (e) {
        window.location.href = buttonUrl;
    }); });
    if (lcv.__kt == 1) {
        domel(footer)
            .addChild('button', function (b) { return b
            .addClass('kfrm-button')
            .addText('Extend trial')
            .on('click', function (e) {
            window.location.href = 'https://korzh.com/account';
        }); });
    }
}
//# sourceMappingURL=lc-dialog.js.map